var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.66667 13C5.66667 12.7348 5.74129 12.4804 5.87413 12.2929C6.00697 12.1054 6.18714 12 6.375 12H10.625C10.8129 12 10.993 12.1054 11.1259 12.2929C11.2587 12.4804 11.3333 12.7348 11.3333 13C11.3333 13.2652 11.2587 13.5196 11.1259 13.7071C10.993 13.8946 10.8129 14 10.625 14H6.375C6.18714 14 6.00697 13.8946 5.87413 13.7071C5.74129 13.5196 5.66667 13.2652 5.66667 13ZM2.83333 7C2.83333 6.73478 2.90796 6.48043 3.0408 6.29289C3.17364 6.10536 3.3538 6 3.54167 6H13.4583C13.6462 6 13.8264 6.10536 13.9592 6.29289C14.092 6.48043 14.1667 6.73478 14.1667 7C14.1667 7.26522 14.092 7.51957 13.9592 7.70711C13.8264 7.89464 13.6462 8 13.4583 8H3.54167C3.3538 8 3.17364 7.89464 3.0408 7.70711C2.90796 7.51957 2.83333 7.26522 2.83333 7ZM0 1C0 0.734784 0.0746279 0.48043 0.207466 0.292893C0.340304 0.105357 0.520472 0 0.708333 0H16.2917C16.4795 0 16.6597 0.105357 16.7925 0.292893C16.9254 0.48043 17 0.734784 17 1C17 1.26522 16.9254 1.51957 16.7925 1.70711C16.6597 1.89464 16.4795 2 16.2917 2H0.708333C0.520472 2 0.340304 1.89464 0.207466 1.70711C0.0746279 1.51957 0 1.26522 0 1Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter_icon.ca292ab92f0b5567e0774eaf4fb6082a.svg";
export { ForwardRef as ReactComponent };